import { useEffect, useState } from "react";
import { tc } from "../lib/themeStyles";

export default function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("mal_cookies")) {
      setTimeout(() => setShow(true), 800);
    }
  }, []);

  const accept = () => {
    localStorage.setItem("mal_cookies", "accepted");
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-6 md:right-6 z-50 animate-slide-down">
      <div className="glass max-w-3xl mx-auto rounded-2xl px-5 py-4 flex flex-col md:flex-row items-start md:items-center gap-4 shadow-2xl">
        <p className="text-[13px] leading-[1.6] flex-1" style={tc.primary}>
          We use cookies to improve your experience and analyze site traffic. By continuing, you
          agree to our Cookie Policy.
        </p>
        <div className="flex items-center gap-2 shrink-0">
          <button type="button" onClick={accept} className="btn-ghost !py-2 !px-4 text-[13px]">
            Manage Preferences
          </button>
          <button type="button" onClick={accept} className="btn-primary !py-2 !px-4 text-[13px]">
            Accept All
          </button>
        </div>
      </div>
    </div>
  );
}
